export const getSelectedValues = (
  options: string[],
  selections: number[]
): string[] => options.filter((_, index) => selections[index] === 1);

export interface ListenerProfileMappings {
  soothingSound: string[];
  wantThreeThings: string[];
  changeType: string[];
  changeHowMuch: Record<number, string>;
}

export const LISTENER_PROFILE_MAPPINGS: ListenerProfileMappings = {
  soothingSound: [
    "campfire",
    "coffee shops",
    "a fan",
    "the forest",
    "rain",
    "evening streets",
    "mechanical hums",
    "waves",
    "white noise",
    "wind",
  ],
  wantThreeThings: [
    "to improve yourself & the world",
    "to feel helpful & loved",
    "to be valued & successful",
    "to express creatively & be seen as special",
    "to feel knowledgeable & competent",
    "to feel safe & supported",
    "to feel good & carefree",
    "to be truthful & in charge",
    "to be at peace & bring harmony",
  ],
  changeType: [
    "systemic change",
    "some systemic change",
    "a balance of systemic and individual change",
    "some individual change",
    "individual change",
  ],
  changeHowMuch: {
    1: "very little change",
    2.33: "a little change",
    3.66: "a moderate amount of change",
    5: "a complete change",
  },
};
